/** Local monotonic durations; never subtract clocks from different machines. */
export type ChatTimingStage =
  | 'send_started'
  | 'message_committed'
  | 'admission_received'
  | 'session_starting_observed'
  | 'session_ready_observed'
  | 'run_observed'
  | 'first_text_received'
  | 'first_tool_observed'
  | 'assistant_text_committed'
  | 'terminal_observed'
  | 'error_observed'

export type ChatTimingEvent = {
  conversation_id: string
  request_id: string
  observation_id: string
  source: 'browser'
  stage: ChatTimingStage
  elapsed_ms: number
  run_id?: string
  workspace_id?: string
  outcome?: string
}

/** One sample per milestone, including when SSE reconnects replay old events. */
export function createChatTiming(
  identity: Pick<ChatTimingEvent, 'conversation_id' | 'request_id' | 'observation_id'>,
  emit: (event: ChatTimingEvent) => void,
  now: () => number = () => performance.now()
) {
  const started = now()
  const seen = new Set<ChatTimingStage>()
  return {
    requestId: identity.request_id,
    mark(stage: ChatTimingStage, details: Pick<ChatTimingEvent, 'run_id' | 'workspace_id' | 'outcome'> = {}) {
      if (seen.has(stage)) return
      seen.add(stage)
      emit({ ...identity, source: 'browser', stage, elapsed_ms: Math.max(0, now() - started), ...details })
    },
  }
}
